import { render } from "./GridBarangMasuk.vue?vue&type=template&id=68f3e2dc&scoped=true"
import script from "./GridBarangMasuk.vue?vue&type=script&lang=js"
export * from "./GridBarangMasuk.vue?vue&type=script&lang=js"

import "./GridBarangMasuk.vue?vue&type=style&index=0&id=68f3e2dc&scoped=true&lang=css"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f3e2dc"]])

export default __exports__